"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CollectionImage_1 = __importDefault(require("./CollectionImage"));
exports.default = CollectionImage_1.default;
